import { format, isValid } from 'date-fns';

export const API_TIME_FORMAT = 'HHmmss';

export const toDateTimeISOWithoutOffset = (date: Date) => {
    const formattedDateTime = format(date, "yyyy-MM-dd'T'HH:mm:ss'z'");
    return formattedDateTime;
};

export const mergeDateAndTime = (date, time, zeroTime = false) => {
    const [hours, minutes, seconds, milliseconds] = zeroTime
        ? [0, 0, 0, 0]
        : isValid(time)
          ? [time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds()]
          : [date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()];
    const mergedDateTime = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        hours,
        minutes,
        seconds,
        milliseconds
    );
    return mergedDateTime;
};
